import React, { Component } from 'react'
import { typography } from '../styles'
import styled from 'styled-components'

const LogoWrapper = styled.div`
  ${typography.serif}
  font-size: 1.25rem;
  animation: fade-in 1s;
  > * { display: inline-block; }
`
const Title = styled.h1`
  ${typography.pink}
  margin-right: 0.5rem;
  font-weight: normal;
`
const Subtitle = styled.h2`
  font-style: italic;
  font-weight: normal;
`

class Logo extends Component {
  render () {
    return (
      <LogoWrapper>
        <Title>Ceres</Title>
        <Subtitle>Drag It Down On You</Subtitle>
      </LogoWrapper>
    )
  }
}

export default Logo



/** WEBPACK FOOTER **
 ** ./src/components/Logo.js
 **/